// Online or offline, shared by every component: one source of truth, updated by the browser's events.
import { useSyncExternalStore } from "react";

let online = typeof navigator === "undefined" ? true : navigator.onLine;
const listeners = new Set<() => void>();
function set(v: boolean) {
  if (v === online) return;
  online = v;
  listeners.forEach((l) => l());
}
if (typeof window !== "undefined") {
  window.addEventListener("online", () => set(true));
  window.addEventListener("offline", () => set(false));
}

export function isOnline(): boolean {
  return online;
}

export function useOnline(): boolean {
  return useSyncExternalStore((cb) => { listeners.add(cb); return () => listeners.delete(cb); }, () => online, () => true);
}
